import React from 'react';
import BlockLink from '../../common/blockLink/BlockLink';
import './MainView.scss';

class MainView extends React.Component<any, any> {

    render() {
        return (
            <div className="MainView">
                <BlockLink path="map" language="fr" label="Map ushops fr" />
                <BlockLink path="map" language="en" label="Map ushops en" />
                <BlockLink path="map" language="nl" label="Map ushops nl" />
                
                <BlockLink path="sample-bike" language="fr" label="App display fr" />
                <BlockLink path="sample-bike" language="en" label="App display en" />
                <BlockLink path="sample-bike" language="nl" label="App display nl" />

                <BlockLink path="budget-bike" language="fr" label="App budget fr" />
                <BlockLink path="budget-bike" language="en" label="App budget en" />
                <BlockLink path="budget-bike" language="nl" label="App budget nl" />
            </div>
        );
    }
}

export default MainView;
